import type { EventCallback, EventName } from "@tauri-apps/api/event";
import { MockTauri } from "./MockTauri";
import { NullTauri } from "./NullTauri";
import { RealTauri } from "./RealTauri";

export interface InvokePayload {
  cmd: string;
  payload: Record<string, any>;
  id: number;
}

export interface Tauri {
  get enabled(): boolean;
  invoke<T>(command: string, args?: Record<string, any>): Promise<T>;
  emit(event: string, data: any): void;
  listen<Event>(event: EventName, callback: EventCallback<Event>): Promise<() => void>;
  checkUpdate(channel?: "beta" | "release"): Promise<{
    shouldUpdate: boolean;
    manifest: {
      version: string;
      date: string | null;
      body: string | null;
    };
  }>;
  getUpdateForChannel(channel: "beta" | "release"): Promise<boolean>;
  downloadUpdateForLater(channel: "beta" | "release"): Promise<void>;
  installCachedUpdate(): Promise<boolean>;
  downloadAndInstallUpdate(channel: "beta" | "release"): Promise<void>;
  getUpdateChannel(): Promise<"beta" | "release">;
  setUpdateChannel(channel: "beta" | "release"): Promise<void>;
  performSync(): Promise<unknown>;
  getCloseToTrayEnabled(): Promise<boolean>;
  setCloseToTrayEnabled(enabled: boolean): Promise<void>;
}

const mock = import.meta.env.VITE_TAURI_TEST === "1";
let tauri: Tauri;

if (typeof window !== "undefined") {
  if (mock) tauri = new MockTauri();
  else if (window.__TAURI__) tauri = new RealTauri();
  else tauri = new NullTauri();

  // @ts-expect-error
  window.tauri = tauri;
} else {
  tauri = new NullTauri();
}

export default tauri;
